import { Color } from "@opendaw/lib-std";
export const Colors = {
    white: new Color(0, 0, 100),
    blue: new Color(265, 85, 65),
    green: new Color(142, 70, 45),
    yellow: new Color(48, 90, 55),
    cream: new Color(40, 15, 80),
    orange: new Color(28, 90, 55),
    red: new Color(0, 80, 55),
    purple: new Color(270, 80, 60),
    bright: new Color(0, 0, 92),
    gray: new Color(0, 0, 70),
    dark: new Color(0, 0, 50),
    shadow: new Color(0, 0, 35),
    black: new Color(0, 0, 12),
    background: new Color(240, 6, 4),
    panelBackground: new Color(240, 5, 10),
    panelBackgroundBright: new Color(240, 4, 15),
    panelBackgroundDark: new Color(240, 6, 7)
};
export const initializeColors = (root) => {
    Object.entries(Colors).forEach(([name, value]) => {
        const cssName = name.replace(/([A-Z])/g, "-$1").toLowerCase();
        root.style.setProperty(`--color-${cssName}`, value.toString());
    });
};
